import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Alert, Box, Container, Snackbar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { CONSTANTS, STRINGS } from 'src/commons';
import { commonReducerAction } from 'src/redux/reducers/common';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { dietPlanReducerAction } from 'src/redux/reducers/dietPlan';
import { deleteDietPlan, getDietPlans } from 'src/api/dietPlan';
import DietPlanResults from 'src/components/dietPlan/DietPlanResult';
import Toolbar from 'src/components/dietPlan/Toolbar';
import ConfirmDialog from 'src/components/ConfirmationBox';

const DietPlan = () => {
  const { startLoading, stopLoading } = loaderReducerAction;
  const [dietPlans, setDietPlans] = useState([]);
  const history = useNavigate();
  const dispatch = useDispatch();
  const { user, gymId } = useSelector((state) => state.common);
  const { dietPlanList } = useSelector((state) => state.dietPlan);
  const { updateDietPlans } = dietPlanReducerAction;
  const { logoutUser } = commonReducerAction;
  const [searchLoader, setSearchLoader] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteDietPlanrData, setDeleteDietPlanData] = useState({});
  const [deleting, setDeleting] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  const getData = () => {
    dispatch(startLoading());
    getDietPlans(user, gymId)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN) logoutUser();
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          setDietPlans(res.data?.dietPlans);
          dispatch(updateDietPlans(res.data?.dietPlans));
        }
        dispatch(stopLoading());
      })
      .catch((err) => {
        dispatch(stopLoading());
        console.log(err);
      });
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onClickRow = (item) => {
    history(CONSTANTS.ROUTES.PRIVATE_ROUTES.EDIT_DIET_PLAN + '/' + item._id);
  };

  const onDelete = (item) => {
    setDeleting(true);
    dispatch(startLoading());
    deleteDietPlan(user, item._id)
      .then((res) => {
        if (res?.status === 200) {
          setSnackbarState({
            open: true,
            message: 'Diet Plan deleted successfully',
            severity: 'success'
          });
        } else if (res?.status !== 200) {
          setSnackbarState({
            open: true,
            message: res?.message || 'Something went wrong',
            severity: 'error'
          });
        }
        setDeleting(false);
        setDeleteModal(false);
        getData();
      })
      .catch((err) => {
        setSnackbarState({
          open: true,
          message: err?.message || 'Something went wrong',
          severity: 'error'
        });
        dispatch(stopLoading());
        setDeleting(false);
        setDeleteModal(false);
      });
  };

  const filterItem = (text) => {
    setDietPlans(
      dietPlanList?.filter((trainer) =>
        trainer?.name?.toLowerCase()?.includes(text?.trim()?.toLowerCase())
      )
    );
  };

  return (
    <>
      <Helmet>
        <title>DietPlan | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            searchLoader={searchLoader}
            filterItem={filterItem}
            text={STRINGS.ADD_DIET_PLAN}
            route={CONSTANTS.ROUTES.PRIVATE_ROUTES.ADD_DIET_PLAN}
          />
          <Box sx={{ pt: 3 }}>
            <DietPlanResults
              dietPlans={dietPlans}
              onEdit={onClickRow}
              onDelete={(item) => {
                setDeleteDietPlanData(item);
                setDeleteModal(true);
              }}
            />
          </Box>
        </Container>
      </Box>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarState.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <div>
          <Alert onClose={handleClose} severity={snackbarState.severity}>
            {snackbarState.message}
          </Alert>
        </div>
      </Snackbar>
      <ConfirmDialog
        heading={'Delete Diet Plan'}
        message={'Do you want to delete the diet plan?'}
        open={deleteModal}
        handleClose={() => {
          setDeleteModal(false);
        }}
        handleConfirm={() => {
          onDelete(deleteDietPlanrData);
        }}
        loading={deleting}
        key={'detete modal'}
      />
    </>
  );
};

export default DietPlan;
